import React from 'react'
import styled from 'styled-components'
import Link from 'atoms/Link'
import OnSiteLink from 'atoms/OnSiteLink'
import { media } from 'tools/browser'
import PropTypes from 'prop-types'
import { ConfigConsumer } from 'contexts/config-context'

const LinkBody = styled.span`
  display: flex;
  flex-flow: column;
  opacity: 0.75;
  padding: 4px 24px;
  min-height: 40px;
  display: flex;
  justify-content: center;
  color: #384047;

  ${media.greaterThan.large`
        padding: 14px 24px;

        &:hover {
            opacity: 1;
            background-color: #edeef0;
        }
    `}
`

const LinkTitle = styled.span`
  font-weight: bold;
`

const LinkImage = styled.span`
  svg {
    height: 40px;
    max-width: 140px;
  }
`

const LinkDetail = styled.span`
  margin: 8px 0 0;
  color: #afb2b7;
  font-weight: lighter;
`

const ListItem = styled.li`
  padding: 0;
  margin: 0;
`

function SubmenuLink(props) {
  const { item, onSiteLink, ...remainingProps } = props
  return (
    <ConfigConsumer>
      {(config) => (
        <ListItem>
          {onSiteLink ? (
            <OnSiteLink
              href={item.url}
              data={item.data}
              onClick={(e) => {
                if (!config.onLinkClick) {
                  return
                }
                e.target.closest('.shgn-dropdown-wrapper').dispatchEvent(
                  new MouseEvent('click', {
                    view: window,
                    bubbles: true,
                    cancelable: true,
                  }),
                )
              }}
              {...remainingProps}
            >
              <LinkBody>
                {item.image && <LinkImage>{item.image}</LinkImage>}
                <LinkTitle>{item.text}</LinkTitle>
                {item.description && <LinkDetail>{item.description}</LinkDetail>}
              </LinkBody>
            </OnSiteLink>
          ) : (
            <Link href={item.url} data={item.data} {...remainingProps}>
              <LinkBody>
                {item.image && <LinkImage>{item.image}</LinkImage>}
                <LinkTitle>{item.text}</LinkTitle>
                {item.description && <LinkDetail>{item.description}</LinkDetail>}
              </LinkBody>
            </Link>
          )}
        </ListItem>
      )}
    </ConfigConsumer>
  )
}

SubmenuLink.propTypes = {
  item: PropTypes.object.isRequired,
  onSiteLink: PropTypes.bool,
}

export default SubmenuLink



// WEBPACK FOOTER //
// ./src/atoms/SubmenuLink/SubmenuLink.js